import React from "react";

// Utility component to auto-break text at periods for better typography
export const AutoBreakText: React.FC<{ 
  text: string; 
  className?: string; 
  style?: React.CSSProperties;
}> = ({ text, className, style }) => {
  return (
    <span className={className} style={style}>
      {text.split('.').map((line, index, array) => (
        <span key={index}>
          {line.trim()}
          {index < array.length - 1 && line.trim() !== '' && (
            <>
              .<br />
            </>
          )}
        </span>
      ))}
    </span>
  );
};

// Additional text utility function for other formatting needs
export const formatTextWithBreaks = (text: string, separator: string = '.'): string => {
  return text.split(separator).join(`${separator}\n`);
};

// Utility function to truncate text with ellipsis
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
};

// Utility function to capitalize first letter of each sentence
export const capitalizeText = (text: string): string => {
  return text
    .split('. ')
    .map(sentence => sentence.charAt(0).toUpperCase() + sentence.slice(1))
    .join('. ');
};